/**
 * @todo Move each component to its own file
 * @todo Remove unnecessary generic types on these components
 */
import { FunctionComponent } from 'react';

import { citizenshipOptions, credentialLevelOptions, enrollmentOptions } from '../../constants/dropdownOptions';
import Field from '../../lib/recoil/Form/Field';
import universityEligibilityForm from '../../state/forms/universityElegibilityForm/form';
import { Degree, EnrollmentStatus, UsCitizenshipStatus } from '../../types/eligibility';

import AppSelect from './AppSelect';

interface FieldInputProps<T> {
  disabled?: boolean;
  field: Field<T | null>;
}

const CitizenshipStatusInput: FunctionComponent<FieldInputProps<UsCitizenshipStatus>> = ({
  field,
  disabled,
}) => (
  <AppSelect
    dataCy='citizenship-select-about-you'
    disabled={disabled}
    field={field}
    getOptionByKey={
      (optionKey: UsCitizenshipStatus['code']) => citizenshipOptions.find(
        (option) => option.code === optionKey,
      )
    }
    getOptionKey={(option: UsCitizenshipStatus) => option.code}
    getOptionLabel={(option: UsCitizenshipStatus) => option.description}
    id='citizenship-select'
    label='Citizenship Status'
    options={citizenshipOptions}
  />
);

const EnrollmentStatusInput: FunctionComponent = () => (
  <AppSelect
    dataCy='enrollment-select-aboutyou'
    field={universityEligibilityForm.fields.enrollmentStatus}
    getOptionByKey={
      (optionKey: string) => enrollmentOptions.find(
        (option) => option.id === optionKey,
      )
    }
    getOptionKey={(option: EnrollmentStatus) => option.id}
    getOptionLabel={(option: EnrollmentStatus) => option.description}
    id='enrollment-select'
    label='Enrollment Status'
    options={enrollmentOptions}
  />
);

const DegreeSelectInput: FunctionComponent = () => (
  <AppSelect
    dataCy='degree-select-aboutyou'
    field={universityEligibilityForm.fields.credentialLevel}
    getOptionByKey={
      (optionKey: string) => credentialLevelOptions.find(
        (option) => option.code === optionKey,
      )
    }
    getOptionKey={(option: Degree) => option.code}
    getOptionLabel={(option: Degree) => option.description}
    id='degree-select'
    label='Degree'
    options={credentialLevelOptions}
  />
);

export { CitizenshipStatusInput, DegreeSelectInput, EnrollmentStatusInput };
